export const isValidReturnUrl = (url: string | null | undefined): boolean => {
  if (!url) return false;

  const validPrefixes = ['/app', '/admin'];

  try {
    const decodedUrl = decodeURIComponent(url);

    if (decodedUrl.includes('://')) return false;
    if (decodedUrl.startsWith('//')) return false;

    return validPrefixes.some((prefix) => decodedUrl.startsWith(prefix));
  } catch {
    return false;
  }
};

export const getValidReturnUrl = (search: string): string | undefined => {
  const parameters = new URLSearchParams(search);
  const returnUrl = parameters.get('returnUrl');

  if (isValidReturnUrl(returnUrl)) {
    return decodeURIComponent(returnUrl!);
  }

  return undefined;
};
